import { render, staticRenderFns } from "./SolicitarPage.vue?vue&type=template&id=2262ba37&scoped=true&"
import script from "./SolicitarPage.vue?vue&type=script&lang=js&"
export * from "./SolicitarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262ba37",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/doctos-oficiales/SolicitarPage.vue
// module id = 202
// module chunks = 20